module.exports = __webpack_public_path__ + "static/media/wedding-catering-1.9081d58d.jpg";